import { useEffect, useState } from 'react'
import { Modal } from './Modal'
import { FreeButton } from '../atom/FreeButton'
import { FreePlanModal } from '../FreePlanModal'
import { useLocation, useNavigate } from 'react-router-dom'
import { UserType } from '../../utils/common'
import { usePostExperiencePlan } from '../../hooks/query/usePostExperiencePlan'
import { useTranslation } from '../../hooks/useTranslation'

import classNames from 'classnames'
import useUserStore from '../../store/useUserStore'
import { useStore } from '../../store/useStore'

export const Footer = () => {
  // fixed bottom-0 left-0 right-0
  const { t } = useTranslation()
  const { pathname } = useLocation()
  const userInfo = useUserStore((state: any) => state.userInfo)
  const { mutate: experiencePlanMutate } = usePostExperiencePlan()
  const { signOutModal, setSignOutModal } = useStore()
  const [isFreePlanModal, SetFreePlanModal] = useState<boolean>(false)
  const navigate = useNavigate()
  const paymentFreePlan = () => {
    if (!userInfo?.userInfo) {
      navigate('/sign-up')
      return
    } else if (userInfo && userInfo?.userType === UserType.체험) {
      navigate('/video-editor')
      return
    }

    experiencePlanMutate('', {
      onSuccess: (data) => {
        navigate('/video-editor')
      },
      onError: () => {},
    })
  }
  useEffect(() => {
    if (signOutModal) {
      document.body.classList.add('overflow-hidden') // Tailwind 유틸리티 클래스 사용
    } else {
      document.body.classList.remove('overflow-hidden')
    }
  }, [signOutModal])
  return (
    <>
      {' '}
      <div
        className={classNames('  bg-[#141415]', {
          'mt-[20px]':
            pathname !== '/' &&
            pathname !== '/coupon-pack' &&
            pathname !== '/challenge',
        })}
      >
        <footer className="flex flex-col items-between justify-center max-w-[1232px] px-4 py-[20px] mx-auto gap-[8px]">
          <h6 className="text-[#FFFFFF] font-bold text-[16px]">
            ANGEL LEAGUE Inc.
          </h6>
          <div className="flex flex-col gap-[8px]">
            <div className="flex flex-col gap-[2px]">
              <p className="text-[#8F929B] text-[12px]">{t('footer.company.name')}</p>
              <p className="text-[#8F929B] text-[12px]">{t('footer.company.ceo')}</p>

              <p className="text-[#8F929B] text-[12px]">
                {t('footer.company.businessNumber')}
              </p>
              <p className="text-[#8F929B] text-[12px]">
                {t('footer.company.address')}
              </p>
              <p className="text-[#8F929B] text-[12px]">
                02-6203-2021 support@capbox.kr
              </p>
            </div>
            <p className="text-[#8F929B] text-[12px]">
              <a
                href="https://solution.fastseller.shop/termofuse"
                target="_blank"
                rel="noreferrer"
              >
                {t('footer.termsOfService')}
              </a>{' '}
              <a
                href="https://www.solution.fastseller.shop/privacypolicy"
                target="_blank"
                rel="noreferrer"
              >
                {t('footer.privacyPolicy')}
              </a>
              {' | '}
              <button
                onClick={() => {
                  setSignOutModal(true)
                }}
              >
                {t('footer.withdraw')}
              </button>
            </p>
            <p className="text-[#8F929B] text-[12px] flex gap-2">
              <a
                className="text-white"
                href="https://blog.fastseller.shop/"
                target="_blank"
                rel="noreferrer"
              >
                {t('footer.fastSeller')}
              </a>
            </p>
            <p className="text-[#5E6068] text-[14px]">
              Copyright © AngelLeague All rights reserved.
            </p>
          </div>
        </footer>
        {signOutModal && (
          <Modal isModal={signOutModal}>
            <div className="bg-white w-[400px] h-[184px] p-[20px] border-t rounded-t-[20px] z-50">
              <div className="flex flex-col items-center justify-center h-full gap-[24px]">
                <p className="font-bold text-[18px] text-error">{t('footer.modal.withdrawTitle')}</p>
                <div>
                  <p className="">
                    {t('footer.modal.withdrawMessage')}
                  </p>
                </div>
              </div>
            </div>
            <div className="w-[400px] bg-main h-[60px] border-b border-main rounded-b-[20px] flex justify-center items-center font-bold">
              <button
                className="text-white w-[400px]"
                onClick={() => {
                  setSignOutModal(false)
                }}
              >
                {t('footer.modal.confirm')}
              </button>
            </div>
          </Modal>
        )}{' '}
        {isFreePlanModal && (
          <FreePlanModal
            isFreePlanModal={isFreePlanModal}
            setFreePlanModal={SetFreePlanModal}
          />
        )}
      </div>
    </>
  )
}
